<template>
  <!-- banner topo-->
  <div v-if="bannerTopo != ''" class="slider-area">
    <div class="slider-height2 slider-bg2 d-flex align-items-center">
      <div class="container">
        <div class="row align-items-center">
          <div class="offset-xl-1 col-xl-5 col-lg-5 col-md-5">
            <div class="hero-caption hero-caption2">
              <h2>{{ bannerTopo[0].itiNome }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END banner topo-->

  <!-- noticia -->
  <section class="blog_area single-post-area section-padding">
  <div v-if="linhaTextoNoticia != ''" class="container">
    <div class="row justify-content-center">
      <div class="col-md-10">
        <div class="posts-list-avance">
          <div class="single-post">

            <div class="blog_item_img">
              <img :src="$imgURL + linhaTextoNoticia.insInstitucionalImagens[0].itgUrlImagem"
                   class="media card-img-avance img-cant-red img-fluid">
              <div class="blog_item_date">
                <h3 class="date_day">{{ formattedDateDia(linhaTextoNoticia.itiData1) }}</h3>
                <p class="date_month">{{ formattedDateMes(linhaTextoNoticia.itiData1) }}</p>
              </div>
            </div>

            <div class="blog_details-avance">
              <h2 style="color: #2d2d2d;">{{ linhaTextoNoticia.itiNome }}</h2>
              <p v-html="linhaTextoNoticia.itiResumo1"> </p>
            </div>

            <div class="voltar" style="margin-top: 60px;">
              <a href="#" onclick="window.history.back(); return false;" aria-label="Voltar">
                <p>Voltar</p>
              </a>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>

  <!-- END noticia -->

</template>

<script>
import { useRoute } from 'vue-router';
import { useHead } from '@vueuse/head'
import axios from 'axios';

export default {
  name: 'BlogDetalheView',
  components: {
  },

  setup() {
    const route = useRoute();
    const id = route.params.id;
    const nome = route.params.nome;
    return {
      id,
      nome
    };
  },

  data: () => ({
    bannerTopo: [],
    linhaTextoNoticia: [],
  }),

  methods: {
    /* data */
    formattedDateDia(value) {
      return this.$moment(value).format('DD')
    },
    formattedDateMes(value) {
      const mes = this.$moment(value).format('MM')
      return mes.charAt(0).toUpperCase() + mes.slice(1)
    },

    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

    carregaMetas(texto, titulo) {
      useHead({
        title: 'FiançAqui Garantidora - ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "FiançAqui Garantidora" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },
  },

  created() {
    //aqui banner topo
    axios.get('/Process/InsInstitucional/institucional/27/toponoticias/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        //console.log('banner blog')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca notícia
    axios.get('/Process/InsInstitucional/GetById/' + this.id)
      .then(response => {
        this.linhaTextoNoticia = response.data;
        this.carregaMetas(this.removerTagsHTML(this.linhaTextoNoticia.itiResumo1));
        console.log('linhaTextoNoticia')
        console.log(this.linhaTextoNoticia)
      })
      .catch(error => {
        console.error(error);
      });
  },
}
</script>

<style scoped></style>